import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class RoleService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }


    async getRoles(){
        
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Role" ,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                },
                method: "GET"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async addRolesToUser(user, roles){
        let bodyObject ={
            user: user,
            userRoles: roles
        };
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Role" ,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "POST",
                body: JSON.stringify(bodyObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async removeRolesFromUser(user, roles){
        let bodyObject ={
            user: user,
            userRoles: roles
        };
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Role" ,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "DELETE",
                body: JSON.stringify(bodyObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

}


// WEBPACK FOOTER //
// ./src/service/roleService.js